import { api } from "./api";
import { Category } from "@/types";
import type { FilterOptions } from "@/types/filter";

export class ClothingAttributeService {
  public static async fetchAllCategories() {
    const response = await api.get<Category[]>("/core/v2/clothing-categories/");
    return response.data;
  }

  public static async getFilterOptions() {
    const result = await api.get<FilterOptions>("/core/v2/filter-keys/");
    return result.data;
  }
}
